import { createFileRoute } from '@tanstack/react-router'

import { AccountHubLayout } from '@/features/account-hub/components/account-hub-layout'

export const Route = createFileRoute('/_app/account')({
  component: AccountHubLayout,
})
